import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-300/40">
      <div className="px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            {/* Brand */}
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-movie-2-fill text-primary-500 text-2xl"></i>
                </div>
                <span className="text-lg font-bold font-heading text-foreground-50">天堂影院</span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                高清不缓冲，流畅在线观看。无广告影视，极速播放，蓝光画质享受。汇聚电影大全，免费在线看大片。
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-sm font-semibold text-foreground-200 mb-3">快速链接</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer">首页</Link>
                </li>
                <li>
                  <Link to="/category/all" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer">电影分类</Link>
                </li>
                <li>
                  <Link to="/category/action" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer">动作片</Link>
                </li>
                <li>
                  <Link to="/category/scifi" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer">科幻片</Link>
                </li>
              </ul>
            </div>

            {/* Categories */}
            <div>
              <h4 className="text-sm font-semibold text-foreground-200 mb-3">热门分类</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/category/comedy" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer">喜剧片</Link>
                </li>
                <li>
                  <Link to="/category/romance" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer">爱情片</Link>
                </li>
                <li>
                  <Link to="/category/horror" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer">恐怖片</Link>
                </li>
                <li>
                  <Link to="/category/animation" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer">动画片</Link>
                </li>
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h4 className="text-sm font-semibold text-foreground-200 mb-3">联系方式</h4>
              <ul className="space-y-2">
                <li className="flex items-center gap-2 text-sm text-foreground-600">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-mail-line text-primary-500"></i>
                  </div>
                  <span>contact@tiantangcinema.com</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-foreground-600">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-customer-service-2-line text-primary-500"></i>
                  </div>
                  <span>在线客服 24/7</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-foreground-600">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-map-pin-line text-primary-500"></i>
                  </div>
                  <span>中国 · 北京</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom */}
          <div className="mt-10 md:mt-12 pt-6 border-t border-background-300/40 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-700">
              &copy; 2026 天堂影院. 本站内容仅供交流学习，不存储任何视频文件。
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-700 hover:text-foreground-400 transition-colors duration-200">隐私政策</a>
              <a href="#" className="text-xs text-foreground-700 hover:text-foreground-400 transition-colors duration-200">服务条款</a>
              <a href="#" className="text-xs text-foreground-700 hover:text-foreground-400 transition-colors duration-200">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}